import { PendingIcon } from "../../../../../components/MuiIcons";
import { mainTheme } from "../../../../../theme/mainTheme";
import { HistoryEntryIcon, HistoryEntryMainText, HistoryItemProps, UserInfoDisplay } from "./common";

export const HistoryItemCreated = ({
  item,
  statusesConfig,
}: HistoryItemProps) => {
  return (
    <>
      <HistoryEntryIcon>
        <PendingIcon
          sx={{ height: 20 }}
          fill={mainTheme.palette.primary.main}
        />
      </HistoryEntryIcon>

      <HistoryEntryMainText>New</HistoryEntryMainText>

      <UserInfoDisplay item={item} statusesConfig={statusesConfig} />
    </>
  );
};
